module.exports = __webpack_public_path__ + "img/img.0bf24494.png";